export const TARIFF_CONFIG_FETCH = 'TARIFF_CONFIG_FETCH'
